module.exports = __webpack_public_path__ + "img/login-logo.b42d48f5.png";